import { WEB_COMPONENT_NETWORK_TREE } from '../../webcomponents.constants';
import { NetworkTreeWebComponent } from './component/NetworkTreeWebComponent';

window.customElements.define(WEB_COMPONENT_NETWORK_TREE, NetworkTreeWebComponent);

export { NetworkTreeWebComponent };
